module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-section"
  }, [_c('div', {
    staticClass: "title-section"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.steps[_vm.currentStep].name))]), _vm._v(" "), _c('p', {
    staticClass: "step-indicator"
  }, [_vm._v(_vm._s(_vm.getText((_vm.currentStep + 1), _vm.steps.length)))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep].description)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58307ed4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/StepHeader.vue
// module id = 1681
// module chunks = 1